export default __webpack_public_path__ + "62a9c838c99d073c7ba6ac08698de9a1.woff";